import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const SecondStageCategoriesFilter = ({
    secondStageCategories = [],
    loading,
    filters,
    restoreFilterValues,
    onChangeValue = () => {},
    hidden = false,
}) => (
    <Field
        component={Form.ReduxSelect}
        name='secondStageCategories'
        hidden={hidden}
        options={secondStageCategories}
        disabled={loading}
        placeholder='2nd stage category'
        loading={loading}
        setValue={restoreFilterValues(filters, 'secondStageCategories')}
        multiple
        selection
        search
        onChangeValue={onChangeValue}
    />
);

SecondStageCategoriesFilter.propTypes = {
    secondStageCategories: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    onChangeValue: PropTypes.func,
    hidden: PropTypes.bool,
};
